/**
 * 存储服务接口
 * 定义存储操作的基本契约
 */
export class IStorageService {
  /**
   * 保存数据
   * @param {string} key - 键
   * @param {any} value - 值
   */
  save(/* key, value */) {
    throw new Error('Method not implemented');
  }

  /**
   * 获取数据
   * @param {string} key - 键
   * @returns {any} 值
   */
  get(/* key */) {
    throw new Error('Method not implemented');
  }

  /**
   * 删除数据
   * @param {string} key - 键
   */
  remove(/* key */) {
    throw new Error('Method not implemented');
  }
}
